var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"loading":!!!_vm.inhabitantHistory,"items":_vm.inhabitantHistory,"items-per-page":10},scopedSlots:_vm._u([{key:"item.date_from",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("dateFormat")(item.date_from))+"\n  ")]}},{key:"item.date_to",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("dateFormat")(item.date_to))+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }